import { Fragment, lazy } from "react";
import { Route } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

const HomePage = lazy(() => import("../modules/search/pages/HomePage"));
const ResultsPage = lazy(() => import("../modules/search/pages/ResultsPage"));
const ProviderDetailPage = lazy(
  () => import("../modules/portal/user/providerdetail/pages/ProviderDetailPage"),
);
const FaqPage = lazy(() => import("@/modules/portal/global/legal/pages/FaqPage"));
const PrivacyPage = lazy(() => import("@/modules/portal/global/legal/pages/PrivacyPage"));
const TermsPage = lazy(() => import("@/modules/portal/global/legal/pages/TermsPage"));
const OurMissionPage = lazy(() => import("@/modules/portal/global/legal/pages/OurMissionPage"));
const AboutUsPage = lazy(() => import("@/modules/portal/global/legal/pages/AboutUsPage"));
const ContactUsPage = lazy(() => import("@/modules/portal/global/legal/pages/ContactUsPage"));
const SpecialtiesPage = lazy(() => import("@/modules/portal/global/legal/pages/SpecialtiesPage"));
const InsurancePage = lazy(() => import("@/modules/portal/global/legal/pages/InsurancePage"));
const CareersPage = lazy(() => import("@/modules/portal/global/legal/pages/CareersPage"));
const HomeRemediesPage = lazy(() => import("@/modules/portal/global/legal/pages/HomeRemediesPage"));
const FeaturesPage = lazy(() => import("@/modules/portal/global/legal/pages/FeaturesPage"));
const ProviderGrowthPage = lazy(
  () => import("@/modules/providers-growth/ProviderGrowthPage"),
);
const PatientSupportPage = lazy(() => import("@/modules/patientSupport/pages/PatientSupportPage"));
const CareGuidePage = lazy(() => import("@/modules/patientSupport/pages/CareGuidePage"));
const MicroEntryPage = lazy(() => import("@/features/microentry/MicroEntryPage"));
const HomeRemedyMicroEntryPage = lazy(
  () => import("@/features/microentry/HomeRemedyMicroEntryPage"),
);
const VaccineSchedulerPage = lazy(
  () => import("@/modules/vaccine-scheduler/VaccineSchedulerPage"),
);
const RxPriceComparePage = lazy(
  () => import("@/modules/rx-pricing/pages/RxPriceComparePage"),
);
const OAuthCallbackPage = lazy(() => import("../modules/auth/pages/OAuthCallbackPage"));

export function renderSharedPublicRoutes(includeHome = true) {
  return (
  <Fragment>
    {includeHome ? <Route path={ROUTES.home} element={<HomePage />} /> : null}
    <Route path={ROUTES.results} element={<ResultsPage />} />
    <Route path={ROUTES.rxPriceCompare} element={<RxPriceComparePage />} />
    <Route path={ROUTES.providerDetail} element={<ProviderDetailPage />} />
    <Route path={ROUTES.faq} element={<FaqPage />} />
    <Route path={ROUTES.privacy} element={<PrivacyPage />} />
    <Route path={ROUTES.terms} element={<TermsPage />} />
    <Route path={ROUTES.about} element={<OurMissionPage />} />
    <Route path={ROUTES.aboutUs} element={<AboutUsPage />} />
    <Route path={ROUTES.contact} element={<ContactUsPage />} />
    <Route path={ROUTES.specialties} element={<SpecialtiesPage />} />
    <Route path={ROUTES.insurance} element={<InsurancePage />} />
    <Route path={ROUTES.careers} element={<CareersPage />} />
    <Route path={ROUTES.homeRemedies} element={<HomeRemediesPage />} />
    <Route path={ROUTES.features} element={<FeaturesPage />} />
    <Route path={ROUTES.providersGrow} element={<ProviderGrowthPage />} />
    <Route path={ROUTES.patientSupport} element={<PatientSupportPage />} />
    <Route path={ROUTES.patientSupportCareGuide} element={<CareGuidePage />} />
    <Route path={ROUTES.microEntrySpeciality} element={<MicroEntryPage />} />
    <Route path={ROUTES.microEntrySpecialityWithZip} element={<MicroEntryPage />} />
    <Route path={ROUTES.microEntryTaxonomy} element={<MicroEntryPage />} />
    <Route path={ROUTES.microEntryTaxonomyWithZip} element={<MicroEntryPage />} />
    <Route path={ROUTES.microEntryConversation} element={<MicroEntryPage />} />
    <Route path={ROUTES.microEntryConversationWithZip} element={<MicroEntryPage />} />
    <Route path={ROUTES.microEntryHomeRemedy} element={<HomeRemedyMicroEntryPage />} />
    <Route path={ROUTES.vaccineScheduler} element={<VaccineSchedulerPage />} />
    <Route path={ROUTES.oauthCallback} element={<OAuthCallbackPage />} />
  </Fragment>
  );
}
